import styled from 'styled-components';
import AnchorLink from 'react-anchor-link-smooth-scroll';

export const Container = styled.div`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 0 30px;

  @media (min-width: ${props => props.theme.screen.xs}) {
    max-width: 600px;
  }

  @media (min-width: ${props => props.theme.screen.sm}) {
    max-width: 780px;
  }

  @media (min-width: ${props => props.theme.screen.md}) {
    max-width: 1020px;
  }

  @media (min-width: ${props => props.theme.screen.lg}) {
    max-width: 1260px;
  }

  ${props =>
    props.fluid &&
    `
    max-width: 1200px !important;
  `};
`;

export const Section = styled.div`
  padding: 50px 0 100px;
  overflow: hidden;

  @media (min-width: ${props => props.theme.screen.sm}) {
    padding: 96px 0;
  }

  ${props =>
    props.accent &&
    `background-color: ${
      props.accent === 'secondary'
        ? props.theme.color.white
        : props.theme.color.primary
    }`};
`;

export const Columns = styled.div`
  columns: 1;
  column-span: none;
  column-gap: 50px;

  @media (min-width: ${props => props.theme.screen.md}) {
    columns: 2;
  }

  img {
    width: 100%;
  }

  > blockquote,
  div {
    break-inside: avoid;
  }
`;

export const ColumnsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 50px;
  align-items: ${props => props.alignItems && props.alignItems};

  @media (min-width: ${props => props.theme.screen.md}) {
    grid-template-columns: 1fr 1fr;
  }

  img {
    width: 100%;
  }
`;

export const Brand = styled(AnchorLink)`
  color: ${props => props.theme.color.black};
  text-decoration: none;
  font-family: ${props => props.theme.font.primary};
  ${props => props.theme.font_size.large};
  font-weight: ${props => props.theme.font_weight.bold};
  cursor: pointer;

  @media (min-width: 400px) {
    ${props => props.theme.font_size.larger};
  }

  @media (min-width: ${props => props.theme.screen.md}) {
    ${props => props.theme.font_size.large};
  }

  @media (min-width: ${props => props.theme.screen.lg}) {
    ${props => props.theme.font_size.larger};
  }

  &:hover {
    color: ${props => props.theme.color.black};
    text-decoration: underline;
  }
`;
